import { useEffect, useState } from 'react';
import { Column, Text } from '~/commonComponents';
import { Tab, TabList, TabPanel, Tabs } from '~/commonComponents/Tabs';
import { PendingReviewShiftsTab, TodayShiftsTab } from './components';
import { useActiveShifts } from './hooks';
import { Colors } from '~/themes/colors';

export const ActiveShift = () => {
  const { activeTab: defaultActiveTab, counters } = useActiveShifts();

  const [activeTab, setActiveTab] = useState<number>(defaultActiveTab);

  useEffect(() => {
    setActiveTab(defaultActiveTab);
  }, [defaultActiveTab]);

  if (counters.todays === 0 && counters.reviews === 0) {
    return null;
  }

  return (
    <Column className="dashboard-active-shifts" paddingBlock={24} paddingInline={48} data-cy="active-shifts-container">
      <Text bold fontSize={24} textAlign="center" marginInline="auto" data-cy="active-shifts-title">
        Active Shifts
      </Text>

      <Tabs
        initialTab={activeTab}
        style={{ alignItems: 'start', marginTop: 24, width: '100%' }}
        // @ts-expect-error JS Component
        onChangeTab={setActiveTab}
        data-cy="active-shifts-tabs"
      >
        {/* @ts-expect-error JS Component */}
        <TabList data-cy="active-shifts-tab-list">
          {/* @ts-expect-error JS Component */}
          <Tab title="Today's Shifts" totalCount={counters.todays} dataCy="todays-shifts-tab" />
          {/* @ts-expect-error JS Component */}
          <Tab
            title="Pending Review"
            totalCount={counters.reviews}
            totalCountStyle={
              counters.reviews > 0
                ? {
                    backgroundColor: activeTab === 1 ? Colors.error_500 : Colors.error_100,
                  }
                : {}
            }
            totalCountTextStyle={
              counters.reviews > 0
                ? {
                    color: activeTab === 1 ? Colors.white : Colors.error_500,
                  }
                : {}
            }
            dataCy="pending-review-tab"
          />
        </TabList>
        <TabPanel data-cy="active-shifts-tab-panel">
          <TodayShiftsTab />
          <PendingReviewShiftsTab />
        </TabPanel>
      </Tabs>
    </Column>
  );
};
